export const EMBER = {
  colors: {
    warm: "#8B3A1A", // velvet copper — deep, luxurious
    warmDark: "#1A0A02", // near-black espresso
    warmLight: "#FDDAB0", // amber glow
    coral: "#A8563A", // burnt sienna
    teal: "#5E6E3E", // deep olive
    blue: "#6B5A4E", // dark walnut
    green: "#4E7342", // deep forest
    gold: "#B08030", // rich caramel
    cryo: "#7A8B8E", // frosted slate — warm-leaning cool tone
    embryo: "#C97B5E", // rose clay
    text: "#2A2522", // espresso
    textMid: "#5A4D45",
    textLight: "#8A7D74",
    textFaint: "#B0A49A",
    bg: "#FAF6F2", // cream
    bgEnd: "#F5F0EB",
    border: "#E8E0D8",
    surface: "#FFFFFF",
  },
} as const;

/** Briefly expose the selected state before the next screen enters. */
export const AUTO_ADVANCE_DELAY = 160;
export const ONBOARDING_STEPS = 6; // Welcome doesn't count in step indicator
